/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';

// Data imports
import { navSidebar } from '@/lib/data/site/navSidebar';

// Type Imports
import { NavLink } from '@/lib/types/navLink';

// Style imports
import styles from './sidebar.module.scss';

export default function Sidebar() {
  const pathname = usePathname();

  return (
    <div className={styles.sidebarWrapper}>
      <ul className={styles.sidebarList}>
        {navSidebar.map(({ href, label, mobileOnly, children }: NavLink) => (
          <li key={label} className={classNames({ [styles.hasSubmenu]: children, [styles.mobileOnly]: mobileOnly })}>
            <Link
              href={href ?? '#'}
              className={classNames(styles.level0, { [styles.active]: href && pathname.includes(href) })}
            >
              {label}
            </Link>

            {children && (
              <ul className={classNames(styles.subMenu)}>
                {children.map((childGroup: any, index: number) => (
                  <li key={index}>
                    {childGroup.map(({ href, label, divider, children }: NavLink) => (
                      <span key={label}>
                        <Link href={href ?? '#'}  className={classNames(styles.level1, { [styles.active]: href && pathname.includes(href) })}>
                          {label}
                        </Link>
                        {children && (
                          <ul>
                            {children.map(({ href, label }: NavLink) => (
                              <li key={label}>
                                <Link href={href ?? '#'} className={styles.level2}>
                                  {label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                        {divider && <hr />}
                      </span>
                    ))}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
